export default __webpack_public_path__ + "static/media/disableTick.630f6757.svg";